__turbopack_context__.v({
  "Applied": "ojiiyW_Applied",
  "Discount": "ojiiyW_Discount",
  "DiscountWrapper": "ojiiyW_DiscountWrapper",
  "PlaceThird": "ojiiyW_PlaceThird",
  "Placeholder": "ojiiyW_Placeholder",
  "Price": "ojiiyW_Price",
  "SubTotalItem": "ojiiyW_SubTotalItem",
  "Title": "ojiiyW_Title",
  "Total": "ojiiyW_Total",
});
